import { Global } from '@emotion/react';
import styled from '@emotion/styled';
import Navigation from '@components/Navigation';
import Footer from './Footer';
import tw, { GlobalStyles as ResetAndBasicStyles } from 'twin.macro';
import globalStyles from './../styles/globalStyles';

type Props = {
  children: JSX.Element;
  pageContext: PageContext;
};

const MainLayout = ({ children, pageContext }: Props) => (
  <>
    <ResetAndBasicStyles />
    <Global styles={globalStyles} />
    <Container>
      <NavWrapper>
        <Navigation pageContext={pageContext} />
      </NavWrapper>
      <PageWrapper>
        {children}
        <Footer />
      </PageWrapper>
    </Container>
  </>
);

const Container = styled.main`
  ${tw`block`};
  ${tw`before:fixed before:top-0 before:w-full before:left-0 before:h-2 before:bg-primary before:z-50`}
`;

const NavWrapper = styled.div`
  ${tw`w-128 fixed`};
  ${tw`bg-grey-bluishLight`}
`;

const PageWrapper = styled.div`
  ${tw`pb-8`};
  ${tw`pr-8`};
  ${tw`pl-128 min-w-[740px]`};
`;

export default MainLayout;
